import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TypeSelector from "../../ui/type-selector/TypeSelector";
import { baseTitle } from "../../../constants/messages";
import { formTypes } from "../../../constants/keys";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return { width, height };
}

function CommercialClaim({ onTypeSelect, selected }) {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const visible = useSelector((state) => state.app.visibleSelectors);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [windowDimensions.width]);

  useEffect(() => {
    document.title = baseTitle + " - Report Commercial Claim";
  }, []);

  return (
    <div>
      <div className="selectorContainer">
        {(visible.vehicle|| selected.cauto) && (
          <TypeSelector
            id="vehicle"
            name={formTypes.Vehicle}
            onSelectType={onTypeSelect}
            selected={selected.cauto}
          />
        )}
        {(visible.wc || selected.wc) && (
          <TypeSelector
            id="wc"
            name={formTypes.WorkersComp}
            onSelectType={onTypeSelect}
            selected={selected.wc}
          />
        )}
        {(visible.property || selected.property) && (
          <TypeSelector
            id="property"
            name={formTypes.Property}
            onSelectType={onTypeSelect}
            selected={selected.property}
          />
        )}
        {(visible.liability || selected.gl) && (
          <TypeSelector
            id="gl"
            name={formTypes.Liability}
            onSelectType={onTypeSelect}
            selected={selected.gl}
          />
        )}
      </div>
    </div>
  );
}

export default CommercialClaim;
